module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-main"
  }, [_c('div', {
    staticClass: "hero-main__bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "hero-main__title-box"
  }, [_c('div', {
    staticClass: "hero-main__title"
  }, [_c('h1', {
    staticClass: "hero"
  }, [_vm._v(_vm._s(_vm.props.title))]), (_vm.props.button.true) ? _c('div', {
    staticClass: "hero-main__button",
    on: {
      "click": function($event) {
        _vm.btnFunc(_vm.props.button.func)
      }
    }
  }, [_vm._v(_vm._s(_vm.props.button.text))]) : _vm._e(), (_vm.props.subtitle.true) ? _c('div', {
    staticClass: "hero-main__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.subtitle.text)
    }
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e9f04b1","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero.pug
// module id = 541
// module chunks = 1